// extracted by mini-css-extract-plugin
export default {"libraryscreen":"libraryscreen_bd3ba32f7139b637978c","sidebar":"sidebar_cd79d3abcaf81f3c0d86","appicon":"appicon_ee5370a9b5a3f249a3ad"};